module.exports = __webpack_public_path__ + "static/feature-awards-16dc30f901a2e9be8aef3b154024be9e.png";